const capitalizeFirstLetter = (s: string | null) => {
  if (s == null) return ''

  return s.charAt(0).toUpperCase() + s.slice(1)
}

const SKILL_LEVELS = ['Beginner', 'Intermediate', 'Intermediate High', 'Advanced', 'Advanced 4.5+', 'Mixed-Level']

export const getSkillLevelDisplay = (skillLevel: number | number[] | null | undefined): string => {
  if (skillLevel == null) return 'Unknown'

  // Handle array of skill levels (new format)
  if (Array.isArray(skillLevel)) {
    if (skillLevel.length === 0) return 'Unknown'
    if (skillLevel.length === 1) {
      return SKILL_LEVELS[skillLevel[0]] || 'Unknown'
    }
    // Multiple skill levels - show them joined
    const levels = skillLevel
      .map(level => SKILL_LEVELS[level])
      .filter(Boolean)
    return levels.length > 0 ? levels.join(', ') : 'Unknown'
  }

  // Handle single skill level (legacy format)
  return SKILL_LEVELS[skillLevel] || 'Unknown'
}

// Examples:
// getSkillLevelDisplay([4, 3, 2]) => "Advanced 4.5+, Advanced, Intermediate High"  
// getSkillLevelDisplay([1]) => "Intermediate"
// getSkillLevelDisplay(2) => "Intermediate High" (legacy format)
// getSkillLevelDisplay(null) => "Unknown"

export default capitalizeFirstLetter
